module.exports = __webpack_public_path__ + "img/flag-left.524b0423.svg";